import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import StaticArticlesAddDialog from "./StaticArticlesAddDialog";
import { getData } from "../api/AuthenticatedApiCaller";
import { ArticlesApi } from "../api/AdminApi";

export default function StaticArticlesView() {
  const [editedArticle, setEditedArticle] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [articles, setArticles] = useState(null);
  const [error, setError] = useState(false);
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    if (articles === null || update) {
      fetchData();
    }
    setUpdate(false);
  }, [update]);

  async function fetchData() {
    const [data, error] = await getData(ArticlesApi.getAllArticles);
    if (error) {
      // Handle the error
    } else {
      setArticles(data);
    }
  }

  return (
    <Box>
      {!editedArticle !== null && (
        <StaticArticlesAddDialog
          open={isDialogOpen}
          article={editedArticle}
          save={() => {
            setIsDialogOpen(false);
            setUpdate(true);
          }}
          cancel={() => setIsDialogOpen(false)}
        />
      )}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow key="header">
              <TableCell>Id</TableCell>
              <TableCell>Name</TableCell>
              {articles !== null &&
                articles.languages.map((lang) => (
                  <React.Fragment key={lang}>
                    <TableCell>Title{lang}</TableCell>
                    <TableCell>Text{lang}</TableCell>
                  </React.Fragment>
                ))}
              <TableCell>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {articles !== null &&
              articles["data"].map((article) => (
                <TableRow id={article.id}>
                  <TableCell>{article.id}</TableCell>
                  <TableCell>{article.name}</TableCell>
                  {article.labeledContents.map((content) => (
                    <React.Fragment>
                      <TableCell>{content.label}</TableCell>
                      <TableCell>{content.text}</TableCell>
                    </React.Fragment>
                  ))}
                  <TableCell>
                    <IconButton>
                      <EditIcon
                        onClick={() => {
                          setEditedArticle(article);
                          setIsDialogOpen(true);
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
